'use client';

import { Gamepad2, Trophy, Flame } from 'lucide-react';
import { playerStats } from '../../../lib/games-data';

export function StatCards() {
  const stats = [
    {
      label: 'Played',
      value: playerStats.gamesPlayed,
      icon: Gamepad2,
      gradient: 'from-teal-400 to-teal-500',
    },
    {
      label: 'Won',
      value: playerStats.gamesWon,
      icon: Trophy,
      gradient: 'from-purple-400 to-purple-500',
    },
    {
      label: 'Streak',
      value: playerStats.currentStreak,
      icon: Flame,
      gradient: 'from-orange-400 to-orange-500',
    },
  ];

  return (
    <div
      className="flex flex-wrap gap-4"
      role="list"
      aria-label="Player statistics"
    >
      {stats.map((stat) => {
        const Icon = stat.icon;

        return (
          <article
            key={stat.label}
            className={`group relative flex-1 min-w-37.5 bg-linear-to-br ${stat.gradient} rounded-3xl p-5 text-white shadow-xl transition-all duration-300 hover:scale-105 hover:-rotate-1 cursor-pointer`}
            tabIndex={0}
            aria-label={`${stat.label}: ${stat.value}`}
          >
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-white/10 rounded-full" />

            {/* Content */}
            <div className="relative z-10 flex items-center justify-between">
              
              {/* Left side */}
              <div>
                <p className="text-sm font-semibold opacity-90">
                  {stat.label}
                </p>

                <p className="text-3xl font-extrabold tracking-tight mt-1 drop-shadow-md tabular-nums group-hover:scale-110 transition-transform">
                  {stat.value}
                </p>
              </div>

              {/* Icon bubble */}
              <div className="bg-white/20 p-3 rounded-2xl group-hover:rotate-12 transition-transform duration-300 shadow-lg">
                <Icon className="h-6 w-6" />
              </div>
            </div>

            {/* Special animated flame effect for streak */}
            {stat.label === 'Streak' && (
              <div className="absolute top-2 right-2 text-white/60 animate-pulse">
              </div>
            )}

            {/* Bottom highlight line */}
            <div className="absolute bottom-0 left-0 w-full h-1 bg-white/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </article>
        );
      })}
    </div>
  );
}
